// External Imports
import { useState } from "react";
import { BiSolidDollarCircle } from "react-icons/bi";
import { FaAddressCard } from "react-icons/fa";
import {
  MdDocumentScanner,
  MdPerson,
  MdPersonOff,
  MdPhone,
} from "react-icons/md";

// Internal Imports

/** ========================================================================
 * * CustomerFlags Component
 * This component renders icons that represent a customer's status.
 * ========================================================================== */

export default function CustomerFlags({ customer }) {
  /* ======================  ====================== */
  return (
    <div className="flex space-x-4">
      {new Date(customer.driversLicenseExp) > new Date() ? (
        <FaAddressCard
          className="w-5 h-5 text-green-600"
          title="Driver's License is Good"
        />
      ) : (
        <FaAddressCard
          className="w-5 h-5 text-red-600"
          title="Issue with Driver's License"
        />
      )}
      {customer.unpaidInvoices ? (
        <BiSolidDollarCircle
          className="w-5 h-5 text-red-600"
          title="Has unpaid invoices"
        />
      ) : (
        <BiSolidDollarCircle
          className="w-5 h-5 text-green-600"
          title="No unpaid invoices"
        />
      )}
      {customer.phone ? (
        <MdPhone
          className="w-5 h-5 text-green-600"
          title="Phone number on file"
        />
      ) : (
        <MdPhone
          className="w-5 h-5 text-red-600"
          title="No phone number on file"
        />
      )}
      {!customer.screeningStatus ? (
        <MdDocumentScanner
          className="w-5 h-5 text-stone-400"
          title="No screenings found"
        />
      ) : customer.screeningStatus.toLowerCase() === "approved" ? (
        <MdDocumentScanner
          className="w-5 h-5 text-green-600"
          title="Screening approved"
        />
      ) : customer.screeningStatus.toLowerCase() === "declined" ? (
        <MdDocumentScanner
          className="w-5 h-5 text-red-600"
          title="Screening declined"
        />
      ) : (
        <MdDocumentScanner
          className="w-5 h-5 text-yellow-600"
          title="Screening pending"
        />
      )}
    </div>
  );
}
